import React from "react";

const SidePanelLabeledSection = (props) => (
  <div className="col-xs-12">
    <div className="flex flex-nowrap items-center gap-x-3 mt-5 mb-3 w-full">
      <span className="text-2xl font-bold text-black dark:text-white flex-shrink-0">
        {props.label}
      </span>
      <div
        className="cf-side-panel-labeled-divider flex-1 min-w-0 border-0 border-t-[1px] border-solid border-slate-200 dark:border-slate-700"
        role="presentation"
      />
    </div>
    <div className="w-full min-w-0 cf-side-panel-labeled-section-body">
      {props.children}
    </div>
  </div>
);

export default SidePanelLabeledSection;
